





























































import {
  computed, defineComponent, Ref,
} from '@vue/composition-api';
import store from '@/store/index';
import { IModalData } from '@/services/layers/IModalData';
import NavigationService from '@/services/NavigationService';
import { Marker } from 'leaflet';

const Modal: object = defineComponent({
  props: {
    show: {
      type: Boolean,
      default: false,
      name: 'show',
    },
  },
  name: 'Modal',
  setup() {
    /*eslint-disable */
    const closeOverlay = () => {
      store.commit('closeModal');
    };

    const modalData: Ref<IModalData> = computed(() => store.state.modal.data);

    const modalLastUpdate: Ref<string | undefined> = computed(
      () => {
        if (!!modalData.value.lastUpdate
          && modalData.value.lastUpdate !== 'b/d'
        ) {
          const fullDate = new Date(modalData.value.lastUpdate);
          const date = {
            year: fullDate.getFullYear(),
            month: ("0" + (fullDate.getMonth() + 1)).slice(-2),
            day: ("0" + fullDate.getDate()).slice(-2),
          };
          const time = fullDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

          return `${date.year}-${date.month}-${date.day}  ${time}`;
        }
      }
    )

    const directionLink: Ref<string> = computed(
      () => {
        if (!modalData.value.navigationPoint) {
          return '';
        }

        if (!store.state.userPositionMarker.getLatLng()) {
          return 'user denied geolocation';
        }

        const navigationPoint = modalData.value.navigationPoint as Marker;
        return NavigationService.generateNavigationLink(
          store.state.userPositionMarker.getLatLng(),
          navigationPoint.getLatLng(),
        );
      },
    );

    const navigate = (): void => {
      if (directionLink.value !== 'user denied geolocation') {
        window.open(directionLink.value);
      } else {
        alert('Aby nawigować udostępnij swoja lokalizację');
      }
    };

    return {
      closeOverlay,
      modalData,
      directionLink,
      navigate,
      modalLastUpdate,
    };
  },
});
export default Modal;
